import { OperationsState } from './types'

export default {
  activePins: [],
  timeseries: [],
  loadingTimeseries: false
} as OperationsState
